module.exports = __webpack_public_path__ + "static/media/pic02.27faa3fd.webp";